// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M4 2H12C13.1 2 14 2.9 14 4V9.8C14 10.9 13.1 11.8 12 11.8H6.25C5.83 11.8 5.42 11.95 5.1 12.22L2.65 14.15C2.37 14.37 2 14.17 2 13.82V4C2 2.9 2.9 2 4 2Z',
  'M5.2 4.8H6.1C6.49 4.8 6.8 5.11 6.8 5.5V6.9C6.8 7.95 6.05 8.65 5.1 9',
  'M9.2 4.8H10.1C10.49 4.8 10.8 5.11 10.8 5.5V6.9C10.8 7.95 10.05 8.65 9.1 9',
];
